// import React, { useState } from "react";
// import "./UploadStyle.css";
// import FileUpload from "./FileUpload";
// import ManualUpload from "./ManualUpload";
// import ReusableTabs from "../../pages/ReusableTabs";

// // const UploadPage = () => {
// //   const [uploadType, setUploadType] = useState("file");

// //   return (
// //     <div>
// //       <div className="button-container">
// //         <button
// //           className={`${uploadType === "file" && "text-cyan-600"}`}
// //           onClick={() => setUploadType("file")}
// //         >
// //           File Upload
// //         </button>
// //         |
// //         <button
// //           className={`${uploadType === "manual" && "text-cyan-600"}`}
// //           onClick={() => setUploadType("manual")}
// //         >
// //           Shift Layup Serial Nos.
// //         </button>
// //         <hr></hr>
// //       </div>
// //       {uploadType === "file" && <FileUpload />}
// //       {uploadType === "manual" && <ManualUpload />}
// //     </div>
// //   );
// // };

// const UploadPage = () => {
//   const [activeTab, setActiveTab] = useState(0);
//   const tabs = [
//     { label: 'File Upload', component: <FileUpload /> },
//     { label: 'Shift Layup Serial Nos.', component: <ManualUpload /> },
//   ];

//   return (
//     <ReusableTabs 
//       tabs={tabs}
//       defaultTab={0}
//       activeTab={activeTab}        
//       onTabChange={setActiveTab}   
//       panelStyles={{ padding: '16px' }}
//     />
//   );
// }

// export default UploadPage;

import React, { useState, useEffect } from "react";
import "./UploadStyle.css";
import FileUpload from "./FileUpload";
import ManualUpload from "./ManualUpload";
import ReusableTabs from "../../pages/ReusableTabs";

const UploadPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [hasMtUploadEdit, setHasMtUploadEdit] = useState(false);

  // Check if user has MT_Upload_Edit role
  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setHasMtUploadEdit(roles.includes("MT_Upload_Edit"));
    }
  }, []);

  // Only show "Shift Layup Serial Nos." tab if user has the role
  const tabs = [
    { label: "File Upload", component: <FileUpload /> },
    ...(hasMtUploadEdit
      ? [{ label: "Shift Layup Serial Nos.", component: <ManualUpload /> }]
      : []
    ),
  ];

  // Optional: Reset active tab if the second tab becomes unavailable
  useEffect(() => {
    if (!hasMtUploadEdit && activeTab === 1) {
      setActiveTab(0);
    }
  }, [hasMtUploadEdit, activeTab]);

  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={0}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      panelStyles={{ padding: "16px" }}
    />
  );
};

export default UploadPage;
